import React from 'react';
import { motion } from 'framer-motion';
import { CheckIcon, XIcon } from 'lucide-react';
const forYou = ['Tienes +40 años y sientes pesadez constante.', 'Sufres de "barriga por estrés" que no baja con dieta tradicional.', 'Eres profesional con niebla mental y falta de enfoque.', 'Estás cansado de despertarte con rigidez o dolor articular.'];
const notForYou = ['Buscas una pastilla milagrosa sin cambiar lo que pones en tu plato.', 'No estás dispuesto a dejar los ultraprocesados por solo 3 días.', 'Eres menor de 25 años con un metabolismo que aún funciona a máxima velocidad.'];
export const ForWhom = () => {
  return <section className="py-20 bg-cream" data-id="element-112">
      <div className="max-w-5xl mx-auto px-6 lg:px-8" data-id="element-113">
        <div className="grid md:grid-cols-2 gap-8 md:gap-12" data-id="element-114">
          {/* Para ti si... */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-100px'
        }} transition={{
          duration: 0.6
        }} className="bg-white p-8 rounded-2xl shadow-premium border-t-4 border-forest" data-id="element-115">
            <h3 className="text-2xl font-bold mb-6 text-forest" data-id="element-116">
              PARA TI SI...
            </h3>
            <ul className="space-y-5" data-id="element-117">
              {forYou.map((item, index) => <li key={index} className="flex items-start gap-3" data-id="element-118">
                  <CheckIcon className="w-6 h-6 text-forest flex-shrink-0 mt-0.5" data-id="element-119" />
                  <span className="text-charcoal-light leading-relaxed" data-id="element-120">
                    {item}
                  </span>
                </li>)}
            </ul>
          </motion.div>

          {/* No es para ti si... */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-100px'
        }} transition={{
          duration: 0.6,
          delay: 0.2
        }} className="bg-cream-dark p-8 rounded-2xl border-t-4 border-charcoal-light/20" data-id="element-121">
            <h3 className="text-2xl font-bold mb-6 text-charcoal-light" data-id="element-122">
              NO ES PARA TI SI...
            </h3>
            <ul className="space-y-5" data-id="element-123">
              {notForYou.map((item, index) => <li key={index} className="flex items-start gap-3" data-id="element-124">
                  <XIcon className="w-6 h-6 text-charcoal-light/50 flex-shrink-0 mt-0.5" data-id="element-125" />
                  <span className="text-charcoal-light leading-relaxed" data-id="element-126">
                    {item}
                  </span>
                </li>)}
            </ul>
          </motion.div>
        </div>
      </div>
    </section>;
};